import { createContext, useContext } from 'react';

/**
 * May code on this board WRITE without a user gesture?
 *
 * The board's read-only states are enforced client-side with body classes and
 * CSS (`useAhuPermissions` for the permission/critical-task/network/hybrid
 * downgrades, `.static_version` on `#ahu-board-content` for a frozen snapshot).
 * CSS stops a click; it does not stop an effect — and the server does not close
 * the gap either: `PositioningOnCabinetViewSet.partial_update` is guarded only
 * by the role's `ahu` board-item row, `hybrid_edit_protect`/`static_protect`
 * have no `Positioning` receiver, and `ATOMIC_REQUESTS` is off, so a position
 * PATCH from a read-only board is accepted and kept.
 *
 * So anything that writes on its own — not from a click, a keystroke or a
 * select — must gate on this flag. It is true only when:
 *  - the AHU permission resolves to 'access';
 *  - the project AND the user are loaded (the downgrades read them, so
 *    'access' before they arrive means "not known yet", not "allowed");
 *  - `project.editable` is not false — the server's own per-user answer, false
 *    for an archived project, which the board still opens and whose writes the
 *    position endpoints accept;
 *  - the unit is not a static version.
 *
 * `AhuBoardPage` publishes `deriveAhuPermissions(...).writeAllowed`; the
 * default is false, so a form rendered outside the board writes nothing.
 *
 * Consumers today: the access-door To Floor correction
 * (`forms/accessory/accessDoorFloorClearance.ts`). The two older automatic
 * accessory writes — auto-size (`useAccessoryForm`) and the damper mounting
 * auto-adjust (`DamperForm`) — still test `ahu-view-permission` directly, so
 * they keep writing on a no-access board, before permissions resolve and on a
 * static version. Pointing them here is a follow-up (review of #1928); it
 * changes their behaviour, which this PR deliberately does not.
 */
export const BoardWriteAccessContext = createContext(false);

/** @see BoardWriteAccessContext */
export const useBoardWriteAccess = (): boolean => useContext(BoardWriteAccessContext);
